import store from "../../src/store/index"
//订单状态标识，常量值
const _OrderStatus = {
  '1': '待审核',
  '2': '进行中',
  '3': '已完成',
  '4': '已中止',
  '5': '已作废'
};
//付款状态标识，常量值
const _PaymentStatus = {
  '0': '未付款',
  '1': '待确认',
  '2': '部分付款',
  '3': '已付款'
};

//收货状态标识，常量值
const _ShippingStatus = {
  '1': '待发货',
  '2': '部分发货',
  '3': '全部发货',
};

//退货方式标识，常量值
const _ReturnProductsType = {
  '1': '上门退货',
  '2': '邮寄退货',
};

//退货单状态标识，常量值
const _ReturnProductsStatus = {
  '1': '待审核',
  '2': '待发货',
  '3': '待收货',
  '4': '已完成',
  //  '5': '已中止',
  '6': '已作废'
};

//收款单状态标识，常量值
const _ReceiptStatus = {
  '0': '待商家收款',
  '1': '商家已收款',
  '2': '已作废',
  '3': '支付失败',
}

//采购返点状态标识
const _SalesRebateStatus = {
  '0': '待确认',
  '1': '待审核',
  '2': '已审核',
}

//预付款提现状态标识
const _AdvanceWithdrawStatus = {
  '0': '待支付',
  '1': '已支付'
}
function getText(str, def) {
  if (str == null || str == "NaN" || str == "undefined" || str == "") {
    if (def != null) {
      str = def;
    } else {
      str = "";
    }
  }
  return str;
}

const filters = {
  capitalize1(value) {
    if (!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1)
  },
  getJSONString(obj) { //对象转json字符串
    if (obj instanceof Object) {
      return JSON.stringify(obj);
    } else {
      return "";
    }
  },
  getText: function(str, def) {
    return getText(str, def);
  },
  getImgPath(path, def) {
    if (getText(path) != "") {
      return path;
    } else {
      return def != null ? def : "data:image/svg+xml;base64,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";
    }
  },
  numberFormat(number, decimals, decPoint, thousandsSep) {
    return numberFormatMain(number, decimals != null ? decimals : 2, decPoint != null ? decPoint : '.', thousandsSep != null ? thousandsSep : ',');
  },
  numberFormat_fromSeting_qty(number, decimals, decPoint, thousandsSep) {
    if (typeof store.state.qtyDigit == "undefined") { //没有加载digitSettings.js文件的页面即使调用本方法 也不使用设置的小数点位数
      return numberFormat(number, decimals != null ? decimals : 2, decPoint != null ? decPoint : '.', thousandsSep != null ? thousandsSep : ',');
    } else {
      return numberFormat(number, store.state.qtyDigit, decPoint != null ? decPoint : '.', thousandsSep != null ? thousandsSep : ',');
    }
  },
  numberFormat_fromSeting_price(number, decimals, decPoint, thousandsSep) {
    if (typeof store.state.priceDigit == "undefined") { //没有加载digitSettings.js文件的页面即使调用本方法 也不使用设置的小数点位数
      return numberFormat(number, decimals != null ? decimals : 2, decPoint != null ? decPoint : '.', thousandsSep != null ? thousandsSep : ',');
    } else {
      return numberFormat(number, store.state.priceDigit, decPoint != null ? decPoint : '.', thousandsSep != null ? thousandsSep : ',');
    }
  },
  getStrDateFormatStrDate(Date, defText, hideYear, showS) { //格式化日期
    if (Date == null) {
      return defText;
    } else {
      return getStrDateFormatStrDateMain(Date, hideYear, showS);
    }
  },
  /**
   *  精确计算加法，防止0.15+1.015=0.1649999999999~的问题
   * @param dataOne
   * @param dataTwo
   * @returns {number}
   */
  num_add(dataOne, dataTwo) {
    let dataOneInt = dataOne.toString().split(".")[0];
    let dataOneFloat = "";
    let dataTwoInt = dataTwo.toString().split(".")[0];
    let dataTwoFloat = "";
    let lengthOne = 0;
    let lengthTwo = 0;
    let maxLength = 0;
    if (dataOne.toString().split(".").length == 2) {
      dataOneFloat = dataOne.toString().split(".")[1];
      lengthOne = dataOneFloat.toString().length;
    }
    if (dataTwo.toString().split(".").length == 2) {
      dataTwoFloat = dataTwo.toString().split(".")[1];
      lengthTwo = dataTwoFloat.toString().length;
    }
    maxLength = Math.max(lengthOne, lengthTwo);
    for (let i = 0; i < maxLength - lengthOne; i++) {
      dataOneFloat += "0";
    }
    for (let i = 0; i < maxLength - lengthTwo; i++) {
      dataTwoFloat += "0";
    }
    /**
     *对两个数据进行倍数放大
     *使其都变为整数。因为整数计算
     *比较精确。
     */
    let one = dataOneInt + "" + dataOneFloat;
    let two = dataTwoInt + "" + dataTwoFloat;
    //alert("dataOne:"+dataOne+" dataTwo:"+dataTwo +" one:"+one+" two:"+two);
    /**
     *数据扩大倍数后，经计算的到结果，
     *然后在缩小相同的倍数
     *进而得到正确的结果
     */
    let result = (Number(one) + Number(two)) / Math.pow(10, maxLength);
    return result;
  },
  /**
   * 获取预付款提现状态
   * @param {Object} flag
   */
  getAdvanceWithdrawStatus(flag) {
    let statusText = '待确认'
    if (_AdvanceWithdrawStatus[flag]) {
      statusText = _AdvanceWithdrawStatus[flag];
    }
    return statusText;
  },
  /**
   * 获取采购返点状态
   * @param {Object} flag
   */
  getSalesRebateStatus(flag) {
    let statusText = '待确认'
    if (_SalesRebateStatus[flag]) {
      statusText = _SalesRebateStatus[flag];
    }
    return statusText;
  },
  /**
   * 获取收款单状态
   * @param {Object} flag
   */
  getReceiptStatus(flag) {
    let statusText = '待商家收款'
    if (_ReceiptStatus[flag]) {
      statusText = _ReceiptStatus[flag];
    }
    return statusText;
  },
  /**
   * 获取订单状态
   * @param {Object} flag
   */
  getOrderState(flag) {
    let statusText = '待审核'
    if (_OrderStatus[flag]) {
      statusText = _OrderStatus[flag];
    }
    return statusText;
  },
  /**
   * 获取订单待付款状态
   * @param {Object} flag
   */
  getOrderPaymentState(flag) {
    let statusText = '待确认'
    if (_PaymentStatus[flag]) {
      statusText = _PaymentStatus[flag];
    }
    return statusText;
  },
  /**
   * 获取发货状态
   * @param {Object} flag
   * 已发货  代表 货发完  但是 可能  未签收 或者 并没有签收完
   * 已收货 代表  发货完成并且签收完成
   * 未发完 代表  货没发完（不管发出去的货是否签收完成）
   */
  getOrderTransportState(flag) {
    let statusText = '待审核'
    switch (flag) {
      case 1:
        statusText = '待审核'
        break;
      case 2:
        statusText = '备货中'
        break;
      case 3:
        statusText = '未发完'
        break;
      case 4:
        statusText = '已发货'
        break;
      case 5:
        statusText = '已收货'
        break;
      default:
        statusText = ''
        break;
    }
    return statusText
  },
  /**
   * 获取开发票类型：不开1、普票2、增票3 ,
   * @param {Object} flag
   */
  getInvoiceType(flag) {
    let statusText = '不开票'
    switch (flag) {
      case 1:
        statusText = '不开票'
        break;
      case 2:
        statusText = '普通发票'
        break;
      case 3:
        statusText = '增值税发票'
        break;
      default:
        break;
    }
    return statusText
  },
  /**
   * 获取订单运输类型
   * @param {Object} flag
   */
  getOrderShippingType(flag) {
    let statusText = '商户送货'
    switch (flag) {
      case 1:
        statusText = '商户送货'
        break;
      case 2:
        statusText = '快递'
        break;
      case 3:
        statusText = '货运'
        break;
      case 4:
        statusText = '上门自取'
        break;
      default:
        break;
    }
    return statusText
  },
  /**
   * 付款单状态，区别于订单付款状态
   * @param {Object} flag
   * @param {Object} channel
   */
  getPaymentStatus(flag, channel) {
    let statusText = '待商家收款'
    switch (flag) {
      case 0:
        if (channel == 8) {
          statusText = '待支付';
        } else {
          statusText = '待商家收款';
        }
        break;
      case 1:
        statusText = '商家已收款';
        break;
      case 3:
        statusText = '支付失败';
        break;
      default:
        break;
    }
    return statusText
  },
  /*
  * 获取退货方式
  * 
   */
  getGoodsReturnShippingType(text) {
    let statusText = _ReturnProductsType['1'];
    if(_ReturnProductsType[text]) {
      statusText = _ReturnProductsType[text];
    }
    return statusText;
  },
  /**
   * 获取退货单状态
   * 
   */
  getGoodsReturnStatus(text){
    let statusText = _ReturnProductsStatus['1'];
    if(_ReturnProductsStatus[text]) {
      statusText = _ReturnProductsStatus[text];
    }
    return statusText;
  },
  /*处理地址信息*/
  handleAddressText(address) {
    let addressText = "";
    if (address != null && !!address.address) {
      addressText += address.province != null && address.province.name != null ? address.province.name : "";
      addressText += address.city != null && address.city.name != null ? ">" + address.city.name : "";
      addressText += address.county != null && address.county.name != null ? ">" + address.county.name : "";
      addressText += address.town != null && address.town.name != null ? ">" + address.town.name : "";
      addressText += " " + address.address;
    } else if (address != null || !!address.consigneeAddress) {
      addressText += address.provincename != null ? address.provincename : ''
      addressText += address.cityname != null ? ">" + address.cityname : ''
      addressText += address.countyname != null ? ">" + address.countyname : ''
      addressText += address.townname != null ? ">" + address.townname : ''
      addressText += address.consigneeAddress
    }
    return addressText;
  },
}

export {
  filters
}

function numberFormatMain(number, decimals, decPoint, thousandsSep) {
  //   example 1: numberFormat(1234.56);
  //   returns 1: '1,235'
  //   example 2: numberFormat(1234.56, 2, ',', ' ');
  //   returns 2: '1 234,56'
  //   example 3: numberFormat(1234.5678, 2, '.', '');
  //   returns 3: '1234.57'
  //   example 4: numberFormat(67, 2, ',', '.');
  //   returns 4: '67,00'
  //   example 5: numberFormat(1000);
  //   returns 5: '1,000'
  //   example 6: numberFormat(67.311, 2);
  //   returns 6: '67.31'
  //   example 7: numberFormat(1000.55, 1);
  //   returns 7: '1,000.6'
  //   example 8: numberFormat(67000, 5, ',', '.');
  //   returns 8: '67.000,00000'
  //   example 9: numberFormat(0.9, 0);
  //   returns 9: '1'
  //  example 10: numberFormat('1.20', 2);
  //  returns 10: '1.20'
  //  example 11: numberFormat('1.20', 4);
  //  returns 11: '1.2000'
  //  example 12: numberFormat('1.2000', 3);
  //  returns 12: '1.200'
  //  example 13: numberFormat('1 000,50', 2, '.', ' ');
  //  returns 13: '100 050.00'
  //  example 14: numberFormat(1e-8, 8, '.', '');
  //  returns 14: '0.00000001'
  number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
  let n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep,
    dec = (typeof decPoint === 'undefined') ? '.' : decPoint,
    s = '',
    toFixedFix = function(n, prec) {
      let k = Math.pow(10, prec);
      return '' + (Math.round(n * k) / k).toFixed(prec);
    };
  // Fix for IE parseFloat(0.55).toFixed(0) = 0;
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
}

/**
 *
 * @returns {日期yyyy-MM-dd}
 */
function getStrDateFormatStrDateMain(_date, hideYear, showS) {
  let strDate = "";
  try {
    let strDate2 = _date.replace(/-/g, "/");
    let date = new Date(strDate2); //new Date(_date);
    if(date != null && date != undefined && typeof(date) != "undefined") {
      let seperator1 = "-";
      let month = date.getMonth() + 1;
      let strD = date.getDate();
      if(month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if(strD >= 0 && strD <= 9) {
        strD = "0" + strD;
      }
      if(hideYear) {
        strDate = month + seperator1 + strD;
      } else {
        strDate = date.getFullYear() + seperator1 + month + seperator1 + strD;
      }
      if(showS) {
        strDate += " " + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds()
      }
    } else {
      if(hideYear && showS) {
        strDate = _date.substr(4, (_date.length - 5));
      } else if(hideYear && !showS) {
        strDate = _date.substr(4, 5);
      } else if(!hideYear && showS) {
        strDate = _date;
      } else {
        strDate = _date.substr(0, 10);
      }
    }

  } catch(e) {

  }
  return strDate;
}



// WEBPACK FOOTER //
// ./static/utils/filters.js